module.exports = __webpack_public_path__ + "img/deskshelf22.b7e48336.jpg";